import { usePostControlsCompatibleTriggering } from "api/generated/controls/controls";
import { TriggerCompatibleControlsRequestDto } from "api/generated/model";

export const useTriggerCompatibleControlsQuery = (
    body: TriggerCompatibleControlsRequestDto,
    enabled = true
) =>
    usePostControlsCompatibleTriggering(body, {
        query: {
            select: (response) => response.data,
            enabled,
        },
    });
